import React from "react";
import { BusinessImpactDataTile } from "../../components/businessImpactDataTile/businessImpactDataTile";

export function BusinessImpact(){
    return(
        <div className="business-impact-container">
         <BusinessImpactDataTile/>
        </div>
    )
}